module.exports = __webpack_public_path__ + "static/img/1.42b9d18.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/1.png
// module id = I6Lk
// module chunks = 1